import { useMutation } from '@tanstack/react-query';

import { SignInParameters } from '../../../../../typings/api/skymap/rest/v0/auth';
import { SkyMapAxiosServiceFactory } from '../../../services/axios/skymap-axios-service-factory';
import { RequestParamsToApiPaths } from '../../../utils/typescript-utils';
import { useErrorHandling } from '../../hooks/use-error-handling';
import { Form } from './request-password-reset-link-form';

const useRequestPasswordQuery = () => {
  const { handleError, hasError, clearErrors, getErrorForPath, buildErrorList, excludeErrorPaths } =
    useErrorHandling<RequestParamsToApiPaths<SignInParameters>>();

  const mutation = useMutation({
    mutationFn: (form: Form) =>
      SkyMapAxiosServiceFactory.instance.createPasswordResetTokenServiceV0().requestPasswordReset({
        body: {
          email: form.email,
        },
      }),
    retry: false,
    networkMode: 'always',
    onError: (error) => handleError(error),
    onMutate: () => clearErrors(),
  });

  return { buildErrorList, clearErrors, getErrorForPath, mutation, hasError, excludeErrorPaths };
};

export { useRequestPasswordQuery };
